/**
 * Dieser Wert wird vom trigger in ein _missingvalue-Feld gesetzt, wenn
 * - kein gültiger Fehlwert gesetzt werden kann
 * - ein eventuell vorhandener Messwert aber auch nicht angezeigt werden soll
 *
 * Der Wert wird dann in der Live-Auswertung und in der Auswertung ignoriert
 */
export const HIDE_MISSINGVALUE = 'HIDE_MISSINGVALUE';
